import { SEO } from "@/components/SEO";
import { FileText } from "lucide-react";

const sections = [
  {
    title: "1. General Information",
    items: [
      "1.1. Praroha Greens is an e-commerce platform selling high-quality microgreens.",
      "1.2. By using our website, you confirm that you are at least 18 years old or have permission from a legal guardian.",
    ],
  },
  {
    title: "2. Product Information and Availability",
    items: [
      "2.1. We strive to ensure that all product descriptions, images, and prices are accurate. However, slight variations may occur.",
      "2.2. Product availability is subject to change without notice.",
      "2.3. We reserve the right to discontinue any product at any time.",
    ],
  },
  {
    title: "3. Orders and Payments",
    items: [
      "3.1. By placing an order, you agree to provide accurate and complete information.",
      "3.2. All prices are listed in Rupees and include applicable taxes unless stated otherwise.",
      "3.3. We accept payments via UPI, Net banking, Credit card and Debit card.",
      "3.4. Orders are confirmed only after payment is successfully processed.",
    ],
  },
  {
    title: "4. Shipping and Delivery",
    items: [
      "4.1. Delays in delivery due to unforeseen circumstances will be communicated to customers.",
    ],
  },
  {
    title: "5. Returns and Refunds",
    items: [
      "5.1. Due to the perishable nature of microgreens, we do not accept returns.",
      "5.2. If you receive a damaged or incorrect product, please contact us within 24 hours of delivery with supporting images.",
      "5.3. Refunds or replacements will be issued if the product is damaged during transit or incorrect due to order fulfilment errors.",
    ],
  },
  {
    title: "6. User Conduct",
    items: [
      "6.1. You agree not to misuse our website or engage in any fraudulent activity.",
      "6.2. Unauthorized use of the website may result in legal action.",
    ],
  },
  {
    title: "7. Privacy Policy",
    items: [
      "7.1. Your personal information is handled as per our Privacy Policy.",
    ],
  },
  {
    title: "8. Intellectual Property",
    items: [
      "8.1. All content on the website, including images, logos, and text, is the property of Praroha Greens and may not be used without permission.",
    ],
  },
  {
    title: "9. Limitation of Liability",
    items: [
      "9.1. We are not liable for any indirect, incidental, or consequential damages arising from the use of our website or products.",
    ],
  },
  {
    title: "10. Force Majeure",
    items: [
      "10.1. We shall not be liable for any failure or delay in performing our obligations due to circumstances beyond our control, including but not limited to natural disasters, acts of government, or other force majeure events.",
    ],
  },
  {
    title: "11. Dispute Resolution",
    items: [
      "11.1. In case of any dispute or disagreement, both parties agree to attempt to resolve the matter through mediation or arbitration before resorting to litigation.",
    ],
  },
  {
    title: "12. Consumer Protection Compliance",
    items: [
      "12.1. Praroha Greens complies with applicable consumer protection laws and regulations in India.",
    ],
  },
  {
    title: "13. Governing Law",
    items: [
      "13.1. These terms are governed by the laws of Telangana, India.",
      "13.2. Any disputes shall be resolved in the courts of Telangana, India.",
    ],
  },
  {
    title: "14. Amendments",
    items: [
      "14.1. We reserve the right to modify these Terms and Conditions at any time.",
      "14.2. Any changes will be posted on this page, and continued use of the website constitutes acceptance of the revised terms.",
    ],
  },
];

export default function TermsConditionsPage() {
  return (
    <div className="pt-16 md:pt-20 lg:pt-24" data-testid="terms-conditions-page">
      <SEO title="Terms & Conditions" description="Terms and Conditions for using the Praroha Greens website and purchasing our microgreens products." path="/terms" />

      {/* Hero */}
      <section className="bg-praroha-forest py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mx-auto mb-4">
            <FileText className="w-6 h-6 text-white" />
          </div>
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-white mb-3">Terms & Conditions</h1>
          <p className="text-white/70 text-sm md:text-base max-w-2xl mx-auto">
            Welcome to Praroha Greens! These Terms and Conditions govern your use of our website (www.prarohagreens.com) and the purchase of our microgreens products. By accessing or using our website, you agree to be bound by these terms.
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 md:py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
          {sections.map((section) => (
            <div key={section.title}>
              <h2 className="font-heading text-lg md:text-xl font-semibold text-praroha-forest mb-4">{section.title}</h2>
              <ul className="space-y-3">
                {section.items.map((item, i) => (
                  <li key={i} className="text-sm md:text-base text-muted-foreground leading-relaxed">{item}</li>
                ))}
              </ul>
            </div>
          ))}

          <div className="pt-6 border-t border-border">
            <p className="text-sm text-muted-foreground">
              For any questions or concerns, contact us at{" "}
              <a href="mailto:info@prarohagreens.com" className="text-praroha-forest font-medium hover:underline">info@prarohagreens.com</a>.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
